/**
 * @file   src\mobile\pages\ProDashboard.js
 * @brief  This file is responsible for pro dashboard section in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderMenu from "../components/common/HeaderMenu";
import MenuBottomBar from "../components/v2/menuBottomMobile";
import "../styles/clients.scss";
import { getAgentDashboard } from "../../services/agentClientsService";
import { pageURLs } from "../../constants/pageURLs";
import userProfile from "../../appState/userProfile.js";
import {
  NOT_FREE_OR_MEMBER_PERIOD,
  USER_TYPE_AGENT,
} from "../../constants/common.js";

const ProDashboard = (props) => {
  const navigate = useNavigate();
  const [dashboardCount, setDashboardCount] = useState([]);

  useEffect(() => {
    fetchCount();
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  /**
   * function to call count api
   * @param {*} data
   */
  const fetchCount = async () => {
    await getAgentDashboard({ isFromMobile: true })
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setDashboardCount(responseResult);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const userDetailsFromStore = userProfile();
  const [userDetails, setUserDetails] = useState(null);
  const userType = _.get(userDetails, "UserTypeId", null);
  const period = _.get(userDetails, "period", null);
  const [isPremiumUser, setIsPremiumUser] = useState(null);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
      if (
        userDetailsFromStore[0]?.period !== NOT_FREE_OR_MEMBER_PERIOD &&
        userType === USER_TYPE_AGENT
      ) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  const handleFavNavigation = () => {
    if (userType === USER_TYPE_AGENT && period > NOT_FREE_OR_MEMBER_PERIOD) {
      navigate(pageURLs.clientFavoriteSummary);
    } else {
      navigate(pageURLs.mobileWantAdFavorites);
    }
  };

  return (
    <div className="gitcha-main-wrapper client-management">
      <div className="content-wrapper content-wrapper-h-100-percent">
        <div className="inner-layout-header-new bg-white">
          <HeaderMenu isPremiumUser={isPremiumUser} />
        </div>
        <div className="inner-layout-content-new">
          <div className="menu-wrap bg-white">
            <div
              className="menu-block d-flex justify-content-between align-items-center"
              onClick={() => navigate(pageURLs.myWantAds)}
            >
              <div className="menu-label d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6.61538 9.26101H9.69231V13.9568H6.61538V9.26101ZM22 4.56525V20.2178C21.9999 20.3512 21.9664 20.4823 21.9025 20.5988C21.8386 20.7153 21.7465 20.8132 21.6349 20.8833C21.5233 20.9534 21.396 20.9933 21.2651 20.9992C21.1341 21.0052 21.0038 20.977 20.8865 20.9173L18.1538 19.5271L15.4212 20.9173C15.3143 20.9717 15.1964 21 15.0769 21C14.9574 21 14.8396 20.9717 14.7327 20.9173L12 19.5271L9.26731 20.9173C9.16044 20.9717 9.04258 21 8.92308 21C8.80357 21 8.68572 20.9717 8.57885 20.9173L5.84615 19.5271L3.11346 20.9173C2.99622 20.977 2.86592 21.0052 2.73494 20.9992C2.60397 20.9933 2.47666 20.9534 2.3651 20.8833C2.25355 20.8132 2.16145 20.7153 2.09755 20.5988C2.03365 20.4823 2.00007 20.3512 2 20.2178V4.56525C2 4.15012 2.16209 3.75199 2.4506 3.45845C2.73912 3.16491 3.13044 3 3.53846 3H20.4615C20.8696 3 21.2609 3.16491 21.5494 3.45845C21.8379 3.75199 22 4.15012 22 4.56525ZM11.2308 8.47839C11.2308 8.27082 11.1497 8.07176 11.0055 7.92499C10.8612 7.77822 10.6656 7.69576 10.4615 7.69576H5.84615C5.64214 7.69576 5.44648 7.77822 5.30223 7.92499C5.15797 8.07176 5.07692 8.27082 5.07692 8.47839V14.7394C5.07692 14.947 5.15797 15.146 5.30223 15.2928C5.44648 15.4396 5.64214 15.522 5.84615 15.522H10.4615C10.6656 15.522 10.8612 15.4396 11.0055 15.2928C11.1497 15.146 11.2308 14.947 11.2308 14.7394V8.47839ZM18.9231 13.1741C18.9231 12.9666 18.842 12.7675 18.6978 12.6207C18.5535 12.474 18.3579 12.3915 18.1538 12.3915H13.5385C13.3344 12.3915 13.1388 12.474 12.9945 12.6207C12.8503 12.7675 12.7692 12.9666 12.7692 13.1741C12.7692 13.3817 12.8503 13.5808 12.9945 13.7276C13.1388 13.8743 13.3344 13.9568 13.5385 13.9568H18.1538C18.3579 13.9568 18.5535 13.8743 18.6978 13.7276C18.842 13.5808 18.9231 13.3817 18.9231 13.1741ZM18.9231 10.0436C18.9231 9.83608 18.842 9.63701 18.6978 9.49024C18.5535 9.34347 18.3579 9.26101 18.1538 9.26101H13.5385C13.3344 9.26101 13.1388 9.34347 12.9945 9.49024C12.8503 9.63701 12.7692 9.83608 12.7692 10.0436C12.7692 10.2512 12.8503 10.4503 12.9945 10.597C13.1388 10.7438 13.3344 10.8263 13.5385 10.8263H18.1538C18.3579 10.8263 18.5535 10.7438 18.6978 10.597C18.842 10.4503 18.9231 10.2512 18.9231 10.0436Z"
                    fill="#66B927"
                  />
                </svg>
                <p>
                  {userType === USER_TYPE_AGENT &&
                  period > NOT_FREE_OR_MEMBER_PERIOD
                    ? "All Want-Listings "
                    : "My Want-Listings "}
                  <span>({dashboardCount?.wantAd})</span>
                </p>
              </div>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </span>
            </div>
            <div
              className="menu-block d-flex justify-content-between align-items-center"
              onClick={() => navigate(pageURLs.mobileManageInventory)}
              role="button"
              onKeyDown={() => navigate(pageURLs.mobileManageInventory)}
            >
              <div className="menu-label d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.571 7.751L19.5 7.695V3.75C19.5 3.336 19.164 3 18.75 3H16.75C16.336 3 16 3.336 16 3.75V4.9375L13.6235 3.065C12.6675 2.3115 11.332 2.3115 10.3765 3.065L4.429 7.751C3.521 8.4665 3 9.54 3 10.6965V19.741C3 20.706 3.785 21.491 4.75 21.491H19.25C20.215 21.491 21 20.706 21 19.741V10.6965C21 9.54 20.479 8.4665 19.571 7.751ZM10 16C10 16.276 9.776 16.5 9.5 16.5H7.5C7.224 16.5 7 16.276 7 16V13C7 12.724 7.224 12.5 7.5 12.5H9.5C9.776 12.5 10 12.724 10 13V16ZM17 16C17 16.276 16.776 16.5 16.5 16.5H14.5C14.224 16.5 14 16.276 14 16V13C14 12.724 14.224 12.5 14.5 12.5H16.5C16.776 12.5 17 12.724 17 13V16Z"
                    fill="#022964"
                  />
                </svg>
                <p>
                  {userType === USER_TYPE_AGENT &&
                  period > NOT_FREE_OR_MEMBER_PERIOD
                    ? "All Inventory "
                    : "My Inventory "}
                  <span>({dashboardCount?.Inventory})</span>
                </p>
              </div>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </span>
            </div>
            {userType === USER_TYPE_AGENT &&
            period > NOT_FREE_OR_MEMBER_PERIOD ? (
              <div
                className="menu-block d-flex justify-content-between align-items-center"
                onClick={() => navigate(pageURLs.agentClientListing)}
                onKeyDown={() => navigate(pageURLs.agentClientListing)}
                role="button"
              >
                <div className="menu-label d-flex align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15 10.5C15 10.945 14.868 11.38 14.6208 11.75C14.3736 12.12 14.0222 12.4084 13.611 12.5787C13.1999 12.749 12.7475 12.7936 12.311 12.7068C11.8746 12.62 11.4737 12.4057 11.159 12.091C10.8443 11.7763 10.63 11.3754 10.5432 10.939C10.4564 10.5025 10.501 10.0501 10.6713 9.63896C10.8416 9.22783 11.13 8.87643 11.5 8.62919C11.87 8.38196 12.305 8.25 12.75 8.25C13.3467 8.25 13.919 8.48705 14.341 8.90901C14.7629 9.33097 15 9.90326 15 10.5ZM21 3.75V20.25C21 20.6478 20.842 21.0294 20.5607 21.3107C20.2794 21.592 19.8978 21.75 19.5 21.75H6C5.60218 21.75 5.22064 21.592 4.93934 21.3107C4.65804 21.0294 4.5 20.6478 4.5 20.25V18H3C2.80109 18 2.61032 17.921 2.46967 17.7803C2.32902 17.6397 2.25 17.4489 2.25 17.25C2.25 17.0511 2.32902 16.8603 2.46967 16.7197C2.61032 16.579 2.80109 16.5 3 16.5H4.5V12.75H3C2.80109 12.75 2.61032 12.671 2.46967 12.5303C2.32902 12.3897 2.25 12.1989 2.25 12C2.25 11.8011 2.32902 11.6103 2.46967 11.4697C2.61032 11.329 2.80109 11.25 3 11.25H4.5V7.5H3C2.80109 7.5 2.61032 7.42098 2.46967 7.28033C2.32902 7.13968 2.25 6.94891 2.25 6.75C2.25 6.55109 2.32902 6.36032 2.46967 6.21967C2.61032 6.07902 2.80109 6 3 6H4.5V3.75C4.5 3.35218 4.65804 2.97064 4.93934 2.68934C5.22064 2.40804 5.60218 2.25 6 2.25H19.5C19.8978 2.25 20.2794 2.40804 20.5607 2.68934C20.842 2.97064 21 3.35218 21 3.75ZM17.85 15.3C17.1859 14.4096 16.3003 13.7086 15.2812 13.2666C15.8397 12.7567 16.231 12.0899 16.4037 11.3537C16.5764 10.6175 16.5225 9.84624 16.2491 9.14121C15.9756 8.43617 15.4954 7.83028 14.8715 7.40304C14.2476 6.9758 13.509 6.74718 12.7528 6.74718C11.9966 6.74718 11.2581 6.9758 10.6341 7.40304C10.0102 7.83028 9.52999 8.43617 9.25655 9.14121C8.98311 9.84624 8.92922 10.6175 9.10194 11.3537C9.27466 12.0899 9.66592 12.7567 10.2244 13.2666C9.20328 13.7077 8.31566 14.4088 7.65 15.3C7.59091 15.3788 7.54791 15.4685 7.52346 15.5639C7.49902 15.6593 7.49361 15.7586 7.50754 15.8561C7.52147 15.9536 7.55446 16.0474 7.60464 16.1321C7.65482 16.2169 7.72121 16.2909 7.8 16.35C7.87879 16.4091 7.96845 16.4521 8.06386 16.4765C8.15927 16.501 8.25856 16.5064 8.35607 16.4925C8.45357 16.4785 8.54737 16.4455 8.63212 16.3954C8.71687 16.3452 8.79091 16.2788 8.85 16.2C9.30409 15.5945 9.89291 15.1031 10.5698 14.7647C11.2468 14.4262 11.9932 14.25 12.75 14.25C13.5068 14.25 14.2532 14.4262 14.9302 14.7647C15.6071 15.1031 16.1959 15.5945 16.65 16.2C16.7693 16.3591 16.947 16.4643 17.1439 16.4925C17.3408 16.5206 17.5409 16.4693 17.7 16.35C17.8591 16.2307 17.9643 16.053 17.9925 15.8561C18.0206 15.6592 17.9693 15.4591 17.85 15.3Z"
                      fill="#52C3EC"
                    />
                  </svg>
                  <p>
                    My Clients <span>({dashboardCount?.client})</span>
                  </p>
                </div>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
                      fill="#1B1C1E"
                    />
                  </svg>
                </span>
              </div>
            ) : (
              <></>
            )}
            <div
              className="menu-block d-flex justify-content-between align-items-center"
              onClick={() => handleFavNavigation()}
              onKeyDown={() => handleFavNavigation()}
              role="button"
            >
              <div className="menu-label d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.5 3C15.6267 3 14.7655 3.20332 13.9844 3.59385C13.2034 3.98438 12.524 4.5514 12 5.25C11.2916 4.30553 10.3041 3.60787 9.17719 3.25586C8.0503 2.90385 6.84122 2.91532 5.72122 3.28866C4.60121 3.66199 3.62707 4.37826 2.93676 5.336C2.24646 6.29375 1.875 7.44441 1.875 8.625C1.875 15.3656 11.2406 20.6812 11.6344 20.9062C11.7459 20.969 11.872 21.0013 12 21C12.1281 21.0022 12.2544 20.9698 12.3656 20.9062C14.0903 19.898 15.708 18.7169 17.1937 17.3812C20.4656 14.4375 22.125 11.4937 22.125 8.625C22.125 7.13316 21.5324 5.70242 20.4775 4.64752C19.4226 3.59263 17.9918 3 16.5 3Z"
                    fill="#DA4167"
                  />
                </svg>
                <p>
                  Favorites <span>({dashboardCount?.Favorites})</span>
                </p>
              </div>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-layout-footer-new inner-layout-footer-topfix">
        <div className="bottomMenu bottom-menu-index">
          <MenuBottomBar />
        </div>
      </div>
    </div>
  );
};

export default ProDashboard;
